module.exports = __webpack_public_path__ + "static/media/builder.7ba899c9.png";